module.exports = __webpack_public_path__ + "static/media/new_mission.cc72c4f3.png";